import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {ApplicationRecordFormProps, ApplicationStatus} from '../types';
import {buildInitialValues, FormValues} from './buildInitialValues';
import {stage} from "../../../config/stage";


export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationRecordFormProps) => {

    const onSubmit = (values: FormValues) => {
        const {provisionAutomatically, ...rest} = values;

        if (provisionAutomatically) {
            handleSubmit({
                             ...rest,
                             applicationStatus: ApplicationStatus.CREATING,
                         });
            return;
        }

        handleSubmit(rest);
    };

    const initialValues = buildInitialValues(record);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
